<button fxHide fxShow.gt-sm mat-icon-button (click)="toggle()">
  <mat-icon class="icon-menu"></mat-icon>
</button>
